
import { Button, Pagination, Spin } from "antd";
import { Select, Space } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authuser } from "../../store/Authentication/AuthSlice";
import { useNavigate } from "react-router-dom";
import AcceptedQuoteOceanUserDetails from "../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteOceanUserDetails";
import AcceptedQuoteUserDetails from "../../components/Admin/AcceptedQuoteDetails/AcceptedQuoteUserDetails";

import CustomeHeader from "../../components/Admin/Common/CustomeHeader";

import RowSelectionTable from "../../components/Admin/Common/RowSelectionTable";
import SimpleSelect from "../../components/Admin/Common/SimpleSelect";
import SimpleTable from "../../components/Admin/Common/SimpleTable";
import ViewButton from "../../components/Admin/Common/ViewButton";
// import ViewPage from '../components/Queries/ViewPage'
// import UserDetails from '../components/UserManagement/UserDetails'
import UserDetailsAdmin from "../../components/Admin/UserManagement/UserDetailsAdmin";
import { get_param_url } from "../../functions/Utils";
import { updatenotificationdata } from "../../store/Common/CommonSlice";
import { get_kam_list } from "../../store/Admin/KAM/KAMSlice";
import {
  get_admin_user_list,
  get_admin_user_list_filter,
  get_user_list,
  kam_reassign_user,
} from "../../store/Admin/UserManagement/UserManagementSlice";
import {
  CustomeButton,
  LeftHead,
  SubHeadContainer,
  SubHeadTitle,
  TablePagination,
} from "../../StyledComponents/Common";
import {
  ContentContainer,
  TableTitle,
  TableTop,
} from "../../StyledComponents/CreateKeyAccountManager";
import { organizationlist } from "../../store/Organization/organizationSlice";
import { MainContainer } from "../../StyledComponents/Dashboard";
import { IconImg } from "../../StyledComponents/Header";
import {
  FilterSection,
  LabelItem,
  RightSection,
  SpinContainer,
} from "../../StyledComponents/Queries";
import { render } from "@testing-library/react";
import Organizationdetailspage from "./Organizationdetailspage";
import SearchBox from "../../components/Admin/Common/SearchBox";

function OrganizationTable() {
  const loginedUser = useSelector(authuser);
  const userroles = loginedUser?.userroles;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [searchParams] = useSearchParams();
  const [orgdata, setOrgdata] = useState([]);
  const [pageType, setPageType] = useState("table");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTab, setCurrentTab] = useState("1");
  const [pageSize, setPageSize] = useState(10);
  const [instance, setInstance] = useState({});
  const [query_instance, setQueryInstance] = useState({});
  const [selectedUsers, setSelectUser] = useState([]);
  const [kam_reassign, setKamReassign] = useState(false);
  const [state, setState] = useState({
    filter_value: null,
    reassign_kam: null,
  });

  const [data, setData] = useState([]);
  const [kam_list, setKamList] = useState([]);
  const [kam_reassign_list, setKamReassignList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [reAssignloading, setReassignLoading] = useState(false);
  const [call_list, setCallList] = useState(true);
  const [filtereddata, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [kycFilter, setKycFilter] = useState("all");
  const [total, setTotal] = useState(0);
  // KYC filter and search run on the backend, so both restart from page 1.
  const handleChange = (value) => {
    setKycFilter(value);
    setCurrentPage(1);
  };
  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  console.log("filtereddata", filtereddata);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  //     useEffect(()=>{

  //         if(pageType === 'table' || call_list === true){
  //             setQueryInstance({})
  //         dispatch(organizationlist())
  //         .then(res=>{
  //             console.log('login res => ',res);
  //             // if(res?.payload?.data?.statusCode === 200 ){
  //                 setData(res?.payload?.data)

  //             // }
  //         })
  //         .catch(err=>{
  //             console.error(err);
  //         })
  //     }

  //     // setIsEdit(false)
  // },[])
  useEffect(() => {
    let handler ;
    let queryStringObj =  {};
    if (pageType === "table" || call_list === true) {
      setQueryInstance({});
      if (searchTerm?.length > 0) {
        queryStringObj["search"] = searchTerm;
      }
      queryStringObj['status'] = "all"
      if (kycFilter !== "all") {
        queryStringObj["kyc_status"] = kycFilter;
      }
      queryStringObj["page"] = currentPage;
      queryStringObj["limit"] = pageSize;
      const queryString = new URLSearchParams(queryStringObj).toString();
      console.log("queryString", queryString);

      handler = setTimeout(() => {
      dispatch(organizationlist(queryString))
        .then((res) => {
          console.log("login res => ", res);
          // if(res?.payload?.data?.statusCode === 200 ){
          setData(res?.payload?.data);
          setFilteredData(res?.payload?.data);
          setTotal(res?.payload?.pagination?.total || 0);
          setLoading(false);

          // }
        })
        .catch((err) => {
          console.error(err);
        });
      }, 300)
    }

    return () => {
      clearTimeout(handler);
    };
    // setIsEdit(false)
  }, [pageType , searchTerm, currentPage, pageSize, kycFilter]);

   useEffect(()=>{
     get_kam();
   },[pageType])

  const get_kam = useCallback(()=>{
    if (pageType === "table" || call_list === true) {
    dispatch(get_kam_list(''))
    .then((res) => {
      // console.log('login res => ',res);
      if (res?.payload?.data?.statusCode === 200) {
        setKamList(res?.payload?.data?.data);
        setKamReassignList(res?.payload?.data?.data);
      }
      setCallList(false);
    })
    .catch((err) => {
      console.error(err);
    });
  }
  },[call_list])
  // console.log("85",kam_list)
  useEffect(() => {
    const user_id = get_param_url("user_id");
    console.log(user_id);
    if (user_id && data.length) {
      // setLoading(true)
      let record = data.filter((i) => i._id == user_id)[0];
      // setLoading(true)
      console.log(data, record, user_id);
      handleView(record);
    }
  }, [data]);

  // useEffect(()=>{
  //     if(state.filter_value && kam_list.length){
  //         // let kam_reassign_list = kam_list.filter((i)=> i._id != kam_list[state.filter_value]._id)
  //         // console.log(state,kam_list)
  //         let kam_reassign_list = kam_list.filter((i)=> i._id != state.filter_value)
  //         setKamReassignList(kam_reassign_list)
  //     }
  // },[state.filter_value])

  const handlePageSizeChange = (current, size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const handleView = (record) => {
    // console.log(record,"tfghj")
    setInstance(record);
    setPageType("view_page");
  };

  // const handleFilterChange = (value) => {
  //     // console.log(kam_list)
  //     const kamid=kam_list[value]
  //     // console.log(kamid,"DFGHJK")
  //     // console.log(value,"sdfghnjmk,")
  //     // console.log(kamid?._id,"hjk")
  //     // setKamId(kamid?._id)
  //     // setLoading(true)
  //     // console.log(kam_ids,"sdfghjk")
  //     const param = { kam_id : kamid?._id}
  //     // console.log(param)
  //     dispatch(get_admin_user_list_filter(param))
  //     .then(res=>{
  //         // console.log('login res => ',res);
  //         if(res?.payload?.data?.statusCode === 200 ){
  //             setData(res?.payload?.data?.data)
  //             setLoading(false)
  //         }
  //     })
  //     .catch(err=>{
  //         console.error(err);
  //     })
  //     // setState((prevState)=> {
  //     //     return {
  //     //         ...prevState,
  //     //         filter_value: value,
  //     //         reassign_kam: null
  //     //     }
  //     // })
  // }
  //   console.log("kamid",kam_ids)
  // const handleReassignChange = (value)=> {
  //     setState((prevState)=> {
  //         return {
  //             ...prevState,
  //             reassign_kam:value
  //         }
  //     })
  // }

  // const handleReassignSubmit = (value) => {
  //     // console.log(state.reassign_kam,"sdfghjk")
  //     // const kamid=kam_list[state.reassign_kam]

  //     // console.log(kamid,"DFGHJK")
  //     setReassignLoading(true)
  //     const param = {
  //         kam_id : kamid?._id, //state.reassign_kam
  //         user_id : selectedUsers,
  //     }
  //     // console.log(param)
  //     dispatch(kam_reassign_user(param))
  //     .then(res=>{
  //         // console.log('login res => ',res);
  //         if(res?.payload?.data?.statusCode === 200 ){
  //             setReassignLoading(false)
  //             dispatch(updatenotificationdata(res?.payload?.data))
  //             const kam_id = get_param_url("kam_id")
  //             // console.log(kam_id)
  //             if(kam_id){
  //                 navigate(`/create-key-account-manager?kam_id=${kam_id}`)
  //             }else {
  //                 // let latestData = data.filter((i)=> !selectedUsers.includes(i.id))
  //                 // setData(latestData)
  //                 // console.log(state.filter_value)
  //                 if(state.filter_value){
  //                     // console.log(state.filter_value,state)
  //                     handleFilterChange(state.filter_value)
  //                 }else {
  //                     setCallList(true)
  //                 }
  //                 setSelectUser([])
  //             }
  //         }
  //     })
  //     .catch(err=>{
  //         console.error(err);
  //     })
  // }

  const handleBackArrow = () => {
    setCurrentTab("2");
    setQueryInstance({});
  };
  //   console.log("hiii",state?.filter_value);

  const columns = [
    {
      title: "User ID",
      // dataIndex: 'id',
      dataIndex: "index",
      render: (text, record, index) => {
        // Calculate the actual index based on current page and page size
        console.log(record, "record");
        return (currentPage - 1) * pageSize + index + 1;
      },
    },
    {
      title: "Organization Name ",
      dataIndex: "org_name",
    },
    {
      title: "Contact Person",
      dataIndex: "contact_person",
    },
    {
      title: "City",
      dataIndex: "city_name",
      // Show the org user's city from user_details; fall back to the org city_name.
      render: (text, record) => (
        <span>{record?.user_details?.[0]?.city || record?.city_name}</span>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
    },
    {
      title: "KYC Status",
      dataIndex: "kyc_status",
      render: (text, record) => (
        <span>{record?.kyc_status}</span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <ViewButton handleClick={handleView} data={record} />
      ),
    },
  ];

  //   console.log("hi2",state,kam_list,selectedUsers);
  console.log(query_instance, "hi");
  return (
    <MainContainer>
      <CustomeHeader
        title="Organization Management"
        description="View all organizations in the system and the complete action."
      />
      {pageType === "table" ? (
        <>
          <div className="mt-4 tableResponsiveASAP">
          <ContentContainer>
            <TableTop>
              <TableTitle>Organization List </TableTitle>
              <RightSection>
                {/* {selectedUsers.length ? 
                        <FilterSection>
                            
                            {kam_reassign ? 
                                <SimpleSelect options={kam_reassign_list} width="180px" value={state.reassign_kam} handleChange={handleReassignChange} placeholder="Select KAM to Assign" />
                            : <CustomeButton size='large' onClick={()=> setKamReassign(true)} >KAM Reassign</CustomeButton>}
                            {state.reassign_kam ? 
                                    <CustomeButton size='large' loading={reAssignloading} onClick={()=> handleReassignSubmit()} >Submit</CustomeButton>// loading={reAssignloading}
                            : null}
                        </FilterSection>:
                     null} */}
                <FilterSection>
                  <LabelItem>Filter by</LabelItem>
                  <Select
                    style={{ width: 120 }}
                    onChange={handleChange}
                    value={kycFilter}
                    options={[
                      { value: "true", label: "KYC Approved" },
                      { value: "false", label: "KYC Pending" },
                      { value: "all", label: "All" },
                    ]}
                  />
                  {/* <SimpleSelect options={kam_list} width="118px" value={state.filter_value} handleChange={handleFilterChange} placeholder="KYC Status" /> */}
                </FilterSection>
                <SearchBox  searchTerm={searchTerm} setSearchTerm={handleSearchChange}/>
              </RightSection>
            </TableTop>
            {loading ? (
              <SpinContainer className="user-quote">
                <Spin />
              </SpinContainer>
            ) : (
              // <SimpleTable currentPage={currentPage} pageSize={pageSize} columns={columns} data={data} />
              <SimpleTable
                rowKey="_id"
                instance={{ type: "orgmng" }}
                currentPage={currentPage}
                pageSize={pageSize}
                columns={columns}
                data={filtereddata}
                setSelectArchive={setSelectUser}
              />
            )}
          </ContentContainer>
          {total > 0 ? (
            <div className="paginationCustom">
            <TablePagination
              style={{ marginTop: 16, textAlign: "center" }}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange}
              current={currentPage}
              pageSize={pageSize}
              total={total}
              showSizeChanger={false}
              showQuickJumper={false}
            />
            </div>
          ) : null}
          </div>
        </>
      ) : pageType === "view_page" ? (
        <>
          {query_instance?.queryId ? (
            // <ViewPage setPageType={setPageType} instance={query_instance} parent_type="user_management" setQueryInstance={setQueryInstance} setCurrentTab={setCurrentTab} />
            <ContentContainer>
              <SubHeadContainer className="flex-column">
                <LeftHead>
                  <IconImg
                    onClick={() => handleBackArrow()}
                    src={require("../../assets/admin/images/back_page_arrow.png")}
                  />
                  <IconImg onClick={() => handleBackArrow()} />
                  <SubHeadTitle>Details</SubHeadTitle>
                </LeftHead>
              </SubHeadContainer>
              {userroles === "ocean_admin" ? (
                <AcceptedQuoteOceanUserDetails
                  instance={query_instance}
                  setQueryInstance={setQueryInstance}
                  setPageType={setPageType}
                />
              ) : (
                <AcceptedQuoteUserDetails
                  instance={query_instance}
                  setQueryInstance={setQueryInstance}
                  setPageType={setPageType}
                />
              )}
            </ContentContainer>
          ) : (
            <ContentContainer>
              {/* <ContentHead title="User Details"  handleClick={()=> setPageType("table")} /> */}
              {/* <UserDetailsAdmin instance={instance} setInstance={setInstance} setQueryInstance={setQueryInstance} tab={currentTab} setPageType={setPageType} kam_list={kam_list} /> */}
              <Organizationdetailspage
                instance={instance}
                setInstance={setInstance}
                setQueryInstance={setQueryInstance}
                tab={currentTab}
                setPageType={setPageType}
                kam_list={kam_list}
              />
            </ContentContainer>
          )}
        </>
      ) : null}
    </MainContainer>
  );
}

export default OrganizationTable;
